import qconsole from 'scripts/lib/qconsole';

export default class EndpointGatewayObserver {
  constructor(context) {
    this.context = context;
  }

  handleAddSuccess(payload) {}

  handleAddErrors(errorsDto) {}

  handleUpdateSuccess(entityId, payload) {
    // endpoint lives in channel configuration
    this.context.stores.channelConfiguration.commitPending();
  }

  handleUpdateErrors(entityId, errorsDto) {
    qconsole.log(`Failed to update endpoint ${entityId} ${JSON.stringify(errorsDto)}`);
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/knowledge_base/endpoint_gateway_observer.js